/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2020,2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'./api/QueryDefinitionModifierAPI'
], (APIFactory, QueryDefinitionModifierAPI) => {
	class V2QueryDefinitionModifier {

		/**
		 * Filter features from definitions which are not supported by V2
		 */
		constructor({ content, dashboardAPI, features }) {
			this.content = content;
			this.dashboard = dashboardAPI;
			features.DataQueryExecution.registerQueryDefinitionModifier(this.getAPI());
		}

		getAPI() {
			if (!this.api) {
				this.api = APIFactory.createAPI(this, [QueryDefinitionModifierAPI]);
			}
			return this.api;
		}

		getType() {
			return 'main';
		}

		modifyQueryDefinitionList(definitions) {
			const vis = this.content.getFeature('Visualization');
			let v2Supported = false;
			if (vis.getType() === 'Crosstab') {
				v2Supported = true;
			}
			return v2Supported ? definitions : [];
		}

	}
	return V2QueryDefinitionModifier;
});
